// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__35fV7","inputWrap":"styles_inputWrap__1sM32","input":"styles_input__26qRd"};